module.exports = __webpack_public_path__ + "media/images/smart_phone/portal/order-39e7879b82dc5997c199da45615dd4ca.png";